var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSessionEnded = function SvgSessionEnded(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.002 40C80.002 17.9086 62.0933 -2.7141e-06 40.0019 -1.74846e-06C17.9106 -7.8281e-07 0.00195041 17.9086 0.00195138 40C0.00195234 62.0914 17.9106 80 40.002 80C62.0933 80 80.002 62.0914 80.002 40Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.002 80.0024C62.0933 80.0024 80.002 62.0938 80.002 40.0024C80.002 17.9111 62.0933 0.00244141 40.002 0.00244141C17.9106 0.00244141 0.00195312 17.9111 0.00195312 40.0024C0.00195312 62.0938 17.9106 80.0024 40.002 80.0024Z",
    fill: "url(#paint0_radial_4965_232354)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.002 40C80.002 17.9086 62.0933 -2.7141e-06 40.0019 -1.74846e-06C17.9106 -7.8281e-07 0.00195041 17.9086 0.00195138 40C0.00195234 62.0914 17.9106 80 40.002 80C62.0933 80 80.002 62.0914 80.002 40Z",
    fill: "url(#paint1_linear_4965_232354)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.002 40C80.002 17.9086 62.0933 -2.7141e-06 40.0019 -1.74846e-06C17.9106 -7.8281e-07 0.00195041 17.9086 0.00195138 40C0.00195234 62.0914 17.9106 80 40.002 80C62.0933 80 80.002 62.0914 80.002 40Z",
    fill: "url(#paint2_radial_4965_232354)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4965_232354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3122 34.9015L52.1455 27.5682C51.8758 27.3523 51.5506 27.217 51.2074 27.1778C50.8642 27.1387 50.5169 27.1973 50.2055 27.347C49.8941 27.4966 49.6314 27.7312 49.4475 28.0236C49.2637 28.3161 49.1662 28.6546 49.1663 29V34.5H38.1663C37.6801 34.5 37.2138 34.6932 36.87 35.037C36.5262 35.3808 36.333 35.8471 36.333 36.3334C36.333 36.8196 36.5262 37.2859 36.87 37.6297C37.2138 37.9736 37.6801 38.1667 38.1663 38.1667H49.1663V43.6667C49.1662 44.0122 49.2637 44.3506 49.4475 44.6431C49.6314 44.9356 49.8941 45.1701 50.2055 45.3198C50.5169 45.4694 50.8642 45.5281 51.2074 45.4889C51.5506 45.4498 51.8758 45.3145 52.1455 45.0985L61.3122 37.7652C61.527 37.5935 61.7004 37.3756 61.8195 37.1277C61.9387 36.8799 62.0005 36.6084 62.0005 36.3334C62.0005 36.0584 61.9387 35.7869 61.8195 35.539C61.7004 35.2912 61.527 35.0733 61.3122 34.9015Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8333 30.8333C42.3196 30.8333 42.7859 30.6402 43.1297 30.2964C43.4735 29.9525 43.6667 29.4862 43.6667 29V19.8333C43.6667 19.3471 43.4735 18.8808 43.1297 18.537C42.7859 18.1932 42.3196 18 41.8333 18H19.8333C19.3471 18 18.8808 18.1932 18.537 18.537C18.1932 18.8808 18 19.3471 18 19.8333V51C18 51.2919 18.0697 51.5797 18.2033 51.8392C18.3369 52.0988 18.5306 52.3227 18.7682 52.4923L31.6015 61.659C31.9117 61.8822 32.2845 62.0015 32.6667 62C32.9585 61.9993 33.246 61.9302 33.5063 61.7983C33.8059 61.644 34.0572 61.41 34.2325 61.1222C34.4078 60.8343 34.5004 60.5037 34.5 60.1667V52.8333H41.8333C42.3196 52.8333 42.7859 52.6402 43.1297 52.2964C43.4735 51.9525 43.6667 51.4862 43.6667 51V43.6667C43.6667 43.1804 43.4735 42.7141 43.1297 42.3703C42.7859 42.0265 42.3196 41.8333 41.8333 41.8333C41.3471 41.8333 40.8808 42.0265 40.537 42.3703C40.1932 42.7141 40 43.1804 40 43.6667V49.1667H34.5V29.0293C34.501 28.7371 34.4322 28.4488 34.2992 28.1886C34.1662 27.9284 33.9729 27.7037 33.7355 27.5333L25.5387 21.6667H40V29C40 29.4862 40.1932 29.9525 40.537 30.2964C40.8808 30.6402 41.3471 30.8333 41.8333 30.8333Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4965_232354)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00039 60.0001C32.9578 60.0001 54.0004 38.9575 54.0004 13.0001C54.0004 9.23543 53.5578 5.57414 52.7217 2.06543C68.5765 7.38006 80.0004 22.356 80.0004 40.0001C80.0004 62.0915 62.0918 80.0001 40.0004 80.0001C25.1828 80.0001 12.247 71.9431 5.33496 59.9711C5.88773 59.9904 6.44292 60.0001 7.00039 60.0001Z",
    fill: "url(#paint3_linear_4965_232354)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4965_232354",
    x: 4.00163,
    y: 0.732096,
    width: 77.3317,
    height: 80.6012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4965_232354"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4965_232354",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4965_232354",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.8542 -0.000289556) rotate(135) scale(69.9745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4965_232354",
    x1: 36.6686,
    y1: -6.66667,
    x2: 0.00194792,
    y2: 47.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4965_232354",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52 19) rotate(143.291) scale(94.7988 78.2511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4965_232354",
    x1: 42.6779,
    y1: 80,
    x2: 52.6609,
    y2: 23.5929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4965_232354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(18 18)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSessionEnded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/session-ended.801c1b93.svg";
export { ForwardRef as ReactComponent };